import RewardsSummaryModule, {
  RewardsSummaryModuleProps,
} from './RewardsSummaryModule';

export type {RewardsSummaryModuleProps};
export default RewardsSummaryModule;
